import { queryOptions } from '@tanstack/react-query'
import accountingDocumentApi from 'api/accountingDocumentApi'
import _ from 'lodash'

export const queryKeys = {
  base: {
    scope: ['general', 'findAccountDocumentModal'],
    entity: 'invoice',
  },
  lists: (params) =>
    queryOptions({
      queryKey: [queryKeys.base, params],

      queryFn: ({ signal }) => {
        return accountingDocumentApi.find(params, signal)
      },
      staleTime: 1000 * 60,
      refetchOnWindowFocus: true,
      retry: false,
      select: (res) => ({
        total: _.get(res, 'totalItems', 0),
        rows: _.get(res, 'items', []),
      }),
    }),
}
